import * as types from '../mutation-types'
import smsService from '../../services/sms'
import userService from '../../services/users'

const state = {
    loading: false,
    errors: null,
    balance:0,
    recipients:[]
}

const actions = {
    getBalance({ commit }) {
        commit(types.SMS_LOADING, true)
        return smsService.getBalance().then(
            response => {
                commit(types.SMS_BALANCE,response.data)
                commit(types.SMS_FAILURE, null)
                commit(types.SMS_LOADING, false)
                return response
            },
            error => {
                commit(types.SMS_FAILURE, error)
                commit(types.SMS_LOADING, false)
                throw error
            }
        )
    },
    send({ commit }, data) {
        commit(types.SMS_LOADING, true)
        commit(types.SMS_FAILURE, null)
        return smsService.send(data).then(
            response => {
               // console.log(response)

                commit(types.SMS_LOADING, false)
                return response
            },
            error => {
                commit(types.SMS_FAILURE, error)
                commit(types.SMS_LOADING, false)
                throw error
            }
        )
    },
    getRecipients({ commit }) {
        commit(types.SMS_LOADING, true)
        commit(types.SMS_FAILURE, null)
        userService.getAll({ utype: "sms_rcpts" }).then(
            response => {
                commit(types.LOAD_RECIPIENTS, response.data)

                commit(types.SMS_LOADING, false)

            },
            error => {
                commit(types.SMS_FAILURE, error)
                commit(types.SMS_LOADING, false)
            }
        )
    },

}

const mutations = {
    [types.LOAD_RECIPIENTS](state, payload) {
        state.recipients=payload;
    },
    [types.SMS_BALANCE](state, payload) {
        state.balance=payload;
    },
    [types.SMS_FAILURE](state, payload) {
        state.errors = payload
    },

    [types.SMS_LOADING](state, payload) {
        state.loading = payload
    },
}


const getters = {
    SMS_BALANCE: state => {
        return state.balance
    },

    SMS_RCPTS: state => {
        return state.recipients
    },

    SMS_ERROR: state => {
        return state.errors
    },

    SMS_LOADING: state => {
        return state.loading
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/sms.js